import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
  useTable,
  useSortBy,
  useFlexLayout,
  useResizeColumns,
  usePagination,
  useGlobalFilter,
  useRowSelect,
} from "react-table";
import { Button, Modal } from 'react-bootstrap';
import Alert from "react-s-alert";
import { gql, useMutation } from '@apollo/client';
import { FormattedMessage } from 'react-intl'

import { ListEditIcon } from '../../../components/svgs';
// import getEncodedImageUrlPres from '../../../helpers/getEncodedImageUrlPres';

import FormSpeaker from '../speakers/speaker-form';

// import { ListEditIcon } from '../../../components/svgs';

function Table({ columns, data, participantsSearch, onSelectedRows, skipPageResetRef }) {
  useEffect(() => {
    // After the table has updated, always remove the flag
    skipPageResetRef.current = false
  })
// console.log(" checking inside participant list page -----------------------",data)
  // Use the state and functions returned from useTable to build your UI
  const defaultColumn = React.useMemo(
    () => ({
      // When using the useFlexLayout:
      minWidth: 50, // minWidth is only used as a limit for resizing
      width: 150, // width is used for both the flex-basis and flex-grow
      maxWidth: 200 // maxWidth is only used as a limit for resizing
    }),
    []
  );
  const {
    getTableProps,
      getTableBodyProps,
      headerGroups,
      prepareRow,
      pageOptions,
      page,
      previousPage,
      nextPage,
      setPageSize,
      canPreviousPage,
      canNextPage,
      setGlobalFilter,
      selectedFlatRows,
      state: { pageIndex },
    } = useTable(
      {
        columns,
        data,
        defaultColumn,
        // autoResetPage: !skipPageReset,
        // updateMyData,
        // initialState: { pageIndex: 1 }

        autoResetPage: !skipPageResetRef.current,
        autoResetExpanded: !skipPageResetRef.current,
        autoResetGroupBy: !skipPageResetRef.current,
        autoResetSelectedRows: !skipPageResetRef.current,
        autoResetSortBy: !skipPageResetRef.current,
        autoResetFilters: !skipPageResetRef.current,
        autoResetRowState: !skipPageResetRef.current,
      },
      useGlobalFilter,
      useSortBy,
      hooks => {
        hooks.visibleColumns.push(columns => [
          // Let's make a column for selection
          {
            id: 'selection',
            // The header can use the table's getToggleAllRowsSelectedProps method
            // to render a checkbox
            Header: ({ getToggleAllRowsSelectedProps }) => (
              <div>
                <input onClick={() => onSelectedRows(selectedFlatRows)} type="checkbox" {...getToggleAllRowsSelectedProps()} />
              </div>
            ),
            width: 30,
            // The cell can use the individual row's getToggleRowSelectedProps method
            // to the render a checkbox
            Cell: ({ row }) => 
              ['manual', 'list', 'account', 'speaker','website'].includes(row.original.source)
                ? <div>
                    <input onClick={() => onSelectedRows(selectedFlatRows)} type="checkbox" {...row.getToggleRowSelectedProps()} />
                  </div>
                : <div />
          },
          ...columns,
        ])
      },
      useFlexLayout,
      useResizeColumns,
      usePagination,
      useRowSelect,
  );

  React.useEffect(() => {
    onSelectedRows(selectedFlatRows);
  }, [onSelectedRows, selectedFlatRows]);

  useEffect(() => {
    setGlobalFilter(participantsSearch);
  }, [participantsSearch, setGlobalFilter]);

  useEffect(() => {
    setPageSize(15);
  }, [setPageSize]);

  // Render the UI for your table\
  return (
    <React.Fragment>
      <div className="table-responsive">
          <div className="ReactTable participants-list-table" {...getTableProps()}>
            <div className="rt-thead -header">
              {headerGroups.map((headerGroup) => (
                <div className="rt-tr" {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <div
                      className="rt-th"
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                    >
                      {column.render("Header")}
                      <span>
                        {column.isSorted
                          ? column.isSortedDesc
                            ? " 🔽"
                            : " 🔼"
                          : ""}
                      </span>
                      <span
                        {...column.getResizerProps()}
                        className={`resizer ${
                          column.isResizing ? "isResizing" : ""
                        }`}
                      />
                    </div>
                  ))}
                </div>
              ))}
            </div>
            <div className="rt-tbody" {...getTableBodyProps()}>
              {page.map((row, i) => {
                prepareRow(row);
                return (
                  <div className="rt-tr-group" {...row.getRowProps()}>
                      {row.cells.map((cell) => {
                        return (
                          <div className="rt-td" {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </div>
                        );
                      })}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      <div className="text-center pagination justify-content-center">
        <Button
          variant="link"
          onClick={() => previousPage()}
          disabled={!canPreviousPage}
        >
          <img alt="" src="/icons/arrow-left.png" />
        </Button>
        <span style={{ marginTop: "8px" }}>
          {pageIndex + 1} / {pageOptions.length}
        </span>
        <Button
          variant="link"
          onClick={() => nextPage()}
          disabled={!canNextPage}
        >
          <img alt="" src="/icons/arrow-right.png" />
        </Button>
      </div>
    </React.Fragment>
  );
}

const ParticipantsTable = ({ intl, participantsSearch, event, data, editUser, setSelectedParticipants, refetchSpeakersAndAssociations }) => {
  const skipPageResetRef = React.useRef()
  const [speaker, setSpeaker] = useState("");
  const onSelectedRows = useCallback((rows) => {
    setSelectedParticipants(rows
      .map(r => r.original)
      .map(r => ({ id: r.id, email: r.email, password: r.password, cant_delete: r.is_speaker || r.is_association }))
    )
  }, [setSelectedParticipants]);
  console.log("inside ParticipantsTable ---------------",data)
  const [tableData, setTableData] = useState(data);

  const [putEventEngagementUserMutation] = useMutation(gql`
    mutation ($pk_columns: user_pk_columns_input! $_set: user_set_input) {
      update_user_by_pk(pk_columns: $pk_columns, _set: $_set) {
        id
      }
    }
  `, {
    onCompleted: () => {
      Alert.success(intl.formatMessage({id: 'event-engagement-users.update-success'}));
    },
    onError: (err) => {
      console.log(JSON.stringify(err.graphQLErrors[0].message, null, 2));
      Alert.error(`Error: ${err.graphQLErrors[0].message}`)
    }
  });

  let columns = useMemo(() => [
    {
      accessor: "disabled",
      Header: intl.formatMessage({ id: "table.header.state"}),
      filterable: false,
      Cell: (props) => {
        return props.row.original.disabled
          ? <div
          onClick={() => putEventEngagementUserMutation({
            variables: {
              pk_columns: {
                id: props.row.original.id,
              },
              _set: {
                disabled: false
              }
            }
          })}
          className={`${props.row.original.status} pointer d-inline-block`}><img title={intl.formatMessage({id: "state.desactivated"})}  src="/participant-icons/user-false.svg" alt="unlocked" width="24" /></div>
          : <div
              onClick={() => putEventEngagementUserMutation({
                variables: {
                  pk_columns: {
                    id: props.row.original.id,
                  },
                  _set: {
                    disabled: true
                  }
                }
              })}
              className={`${props.row.original.status} pointer participants-list-table`}><img title={intl.formatMessage({id: "state.activated"})} src="/participant-icons/user-true.svg" alt="locked" width="24" /></div>
          
      },
      width: 40,
    },
    {
      accessor: "is_moderator",
      Header:intl.formatMessage({ id: "p.moderator"}),
      Cell: (props) => {
        // return props.row.original.is_moderator
        //   ? <img src="" alt="Is a Moderator" width="24" />
        //   : <img src="/participant-icons/moderator-false.svg" alt="Is not a Moderator" width="24" />
        return props.row.original.is_moderator
          ? <div
             title={intl.formatMessage({id: "moderator.activated"})} 
              onClick={() => putEventEngagementUserMutation({
                variables: {
                  pk_columns: {
                    id: props.row.original.id,
                  },
                  _set: {
                    is_moderator: false
                  }
                }
              })}
              className={`${props.row.original.status} pointer d-inline-block`}
            >
              <img src="/participant-icons/moderator-true.svg" alt="Is a Moderator" width="24" />
            </div>
          : <div
          title={intl.formatMessage({id: "moderator.desactivated"})} 
              onClick={() => putEventEngagementUserMutation({
                variables: {
                  pk_columns: {
                    id: props.row.original.id,
                  },
                  _set: {
                    is_moderator: true
                  }
                }
              })}
              className={`${props.row.original.status} pointer d-inline-block`}
            >
              <img src="/participant-icons/moderator-false.svg" alt="Is not a Moderator" width="24" />
            </div>
      },
      width: 65,
    },
    {
      accessor: "is_speaker",
      Header: intl.formatMessage({ id: "input.presentation.speaker"}),
      width: 65,
      Cell: (props) => {
        return props.row.original.is_speaker
          ? <img src="/participant-icons/speaker-true.svg"  title={intl.formatMessage({id: "speaker.activated"})}  alt="Is an Speaker" width="24" />
          : <img src="/participant-icons/speaker-false.svg"  title={intl.formatMessage({id: "speaker.desactivated"})}  alt="Is not a Speaker" width="24" />
      }
    },
    {
      accessor: "is_association",
      Header: intl.formatMessage({ id: "association.activated"}),
      width: 65,
      Cell: (props) => {
        return props.row.original.is_association
          ? <img src="/participant-icons/association-true.svg" title={intl.formatMessage({id: "association.activated"})} alt="Is an Association" width="24" />
          : <img src="/participant-icons/association-false.svg" title={intl.formatMessage({id: "association.desactivated"})} alt="Is not an Association " width="24" />
      }
    },
    {
      accessor: "source",
      Header: intl.formatMessage({
        id: "header.source",
      }),
      width: 75,
    },
    // {
    //   accessor: "photo",
    //   Header: intl.formatMessage({
    //     id: "header.photo",
    //   }),
    //   disableSortBy: true,
    //   Cell: (props) => {
    //     return (
    //       <div>
    //         {
    //           props.row.original.photo ?
    //           <img src={getEncodedImageUrlPres(props.row.original.photo, 40, 40)} alt={props.row.original.login} />
    //           :
    //           <img src={`https://ui-avatars.com/api/?name=${props.row.original.login}&size=40&color=ff7142`} alt={props.row.original.login} />
    //         }
    //       </div>
    //     )
    //   }
    // },
    {
      accessor: "email",
      Header: intl.formatMessage({
        id: "input.email",
      }),
    },
    {
      accessor: "edit",
      Header: " ",
      disableSortBy: true,
      width: 120,
      Cell: (props) => (
        <div className={props.row.original.status}>
          {
            ['manual', 'list', 'account','website'].includes(props.row.original.source) &&
            <Button className="edit-btn" onClick={() => editUser(props.row.original.id)} variant="link">
              <ListEditIcon />
            </Button>
          }
          {
            props.row.original.source === "speaker" &&
            <Button className="edit-btn" onClick={() => setSpeaker(props.row.original.speaker_id)} variant="link">
              <ListEditIcon />
            </Button>
          }
        </div>
      ),
    },
  ], [editUser, intl, putEventEngagementUserMutation]);

  useEffect(() => {
    skipPageResetRef.current = true
    setTableData(data);
  }, [data, setTableData, skipPageResetRef]);

  return (
    <React.Fragment>
      <Table
        skipPageResetRef={skipPageResetRef}
        onSelectedRows={onSelectedRows}
        participantsSearch={participantsSearch}
        columns={columns}
        data={tableData}
      />
      {
        speaker && <Modal
          size="lg"
          show={!!speaker}
          onHide={() => setSpeaker("")}
          aria-labelledby="add-speaker-modal"
          className="add-speaker-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title id="add-speaker-modal">
              <FormattedMessage id="button.create" />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormSpeaker
              match={{ params: { id: speaker }}}
              embedded={true}
              closeModal={(updatedSpeaker) => {
                setSpeaker("")
              }}
            />
          </Modal.Body>
        </Modal>
      }
    </React.Fragment>
  )
}

export default ParticipantsTable;